import React, { useEffect } from 'react';
const pixelId = '28337288762539657';
type PixelFunction = {
  (...args: unknown[]): void;
  queue: unknown[][];
  loaded: boolean;
  version: string;
  push: PixelFunction;
  callMethod?: PixelFunction;
};
declare global {
  interface Window {
    fbq?: PixelFunction;
    _fbq?: PixelFunction;
  }
}
export function MetaPixel() {
  useEffect(() => {
    try {
      if (typeof window === 'undefined' || window.fbq) return;
      const fbq = ((...args: unknown[]) => {
        if (fbq.callMethod) {
          fbq.callMethod(...args);
        } else {
          fbq.queue.push(args);
        }
      }) as PixelFunction;
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      window.fbq = fbq;
      window._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      fbq('init', pixelId);
      fbq('track', 'PageView');
    } catch {
      // Tracking must never prevent the landing page from rendering.
    }
  }, []);
  return <noscript data-id="element-84" data-mp="13ii194pl498n">
      <img alt="" height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`} data-id="element-85" data-mp="13j1iej7eutlm" />
    </noscript>;
}